import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kgw8becrs: FaireProductEntity = {
  token: "p_4kgw8becrs",
  type: "product",
  name: "cottage notecards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/efdb244563a088dfd2103216aa5512ed6d49d01274c3d2cfae790e754f3ab095.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa0351b9223279f92f689f229bd1cec8f994775ea349ed7d3ddabff780b85835.jpeg",
    "https://cdn.faire.com/fastly/800e2475a1e14919bf9596be9f758c32124f98561e32d0571fdcb4ee3b3309e8.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. These cottage notecards are blank on the inside with charming watercolor illustration of an beach cottage on the front. They bring a touch of cheer to your thank you notes, housewarming gifts, get well wishes, and more.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• Set of eight folded cards + envelopes\n• Blank inside\n• 5.5" x 4.25"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:50.760Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
